import { render, staticRenderFns } from "./MerchantOutlet.vue?vue&type=template&id=ddfd0286"
import script from "./MerchantOutlet.vue?vue&type=script&lang=js"
export * from "./MerchantOutlet.vue?vue&type=script&lang=js"
import style0 from "./MerchantOutlet.vue?vue&type=style&index=0&id=ddfd0286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports